// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react';
import { createUseStyles } from 'react-jss';

// 
// ─── IMPORTING COMPONENTS ───────────────────────────────────────
//
import AccountInfos from '../components/AccountInfos/AccountInfos';
import UserScans from '../components/UserScans/UserScans';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const Account = () => {
  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    accountContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto'
    },
  })
  const classes = useStyle();

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <>
    <div className={classes.accountContainer}>
      <AccountInfos />
      <UserScans />
    </div>
  </>
};

export default Account;